<template>
  <b-modal
    :id="`member-logout`"
    modal-class="modal-style two-footer-btn"
    ref="modal"
  >
    <template>
      <p class="modal-style-title alert-title just-title">確認要登出嗎?</p>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn warn" @click="handleCheckIn">
        登 出
      </button>
      <button class="transparent-btn" @click="$bvModal.hide(`member-logout`)">
        取 消
      </button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {},
  methods: {
    ...mapActions('user', ['logout']),
    routeTo() {
      this.$router.push({ name: '首頁' });
    },
    handleCheckIn() {
      this.logout();

      this.$emit('handleCheckIn');
    }
  }
};
</script>
